const getters = {
  tryVuex: state => {
    return state.tryVuex
  },
  contracts: state => {
    return state.contracts
  },
  unassignedProjects: state => {
    return state.unassignedProjects
  },
  paginateUnassignedProjects: state => {
    return state.paginateUnassignedProjects
  },
  assignments: state => {
    return state.assignments
  },
  paginateAssignments: state => {
    return state.paginateAssignments
  },
  projectId: state => {
    return state.projectId
  },
  assignmentId: state => {
    return state.assignmentId
  },
  project: state => {
    return state.project
  },
  assignment: state => {
    return state.assignment
  },
  selects: state => {
    return state.selects
  },
  projects: state => {
    return state.projects
  },    
  taskValidations: state => {
    return state.taskValidations
  },
  assignmentTypes: state => {
    return state.assignmentTypes
  },
  taskValidation: state => {
    return state.taskValidation
  },
  typeEvents: state => {
    return state.typeEvents
  },
  laboral_reference: state => {
    return state.laboral_reference
  }  
}
export default getters;
